import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page dashboard-page"
}
const _hoisted_2 = { class: "page-heading" }
const _hoisted_3 = {
  key: 1,
  class: "dashboard-refresh-message"
}
const _hoisted_4 = { class: "dashboard-actions" }
const _hoisted_5 = ["disabled", "title"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "dashboard-overview-grid" }
const _hoisted_9 = { class: "dashboard-left-column" }
const _hoisted_10 = { class: "panel dashboard-indicators" }
const _hoisted_11 = { class: "dashboard-metric-list" }
const _hoisted_12 = { class: "panel dashboard-chart-panel" }
const _hoisted_13 = { class: "panel dashboard-tasks" }
const _hoisted_14 = { class: "panel-title" }
const _hoisted_15 = { class: "dashboard-task-list" }
const _hoisted_16 = { class: "task-period" }
const _hoisted_17 = {
  key: 0,
  class: "dashboard-empty-tasks"
}
const _hoisted_18 = { class: "panel dashboard-task-stages" }
const _hoisted_19 = { class: "panel-title" }
const _hoisted_20 = { class: "dashboard-task-stage-grid" }
const _hoisted_21 = { class: "panel dashboard-imports" }
const _hoisted_22 = { class: "panel-title" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  class: "loading"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = _resolveComponent("RouterLink")

  return ($setup.data)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _cache[0] || (_cache[0] = _createElementVNode("small", null, "Affiliate CRM", -1 /* CACHED */)),
            _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Дашборд", -1 /* CACHED */)),
            ($setup.data.freshness)
              ? (_openBlock(), _createElementBlock("small", {
                  key: 0,
                  class: _normalizeClass(["dashboard-freshness", {incomplete:!$setup.data.freshness.complete}])
                }, [
                  _createTextVNode("Статистика: " + _toDisplayString($setup.data.freshness.imported_connections) + " из " + _toDisplayString($setup.data.freshness.active_connections) + " активных интеграций · ", 1 /* TEXT */),
                  _createVNode($setup["DualTime"], {
                    value: $setup.data.freshness.updated_at,
                    empty: "ещё не загружена"
                  }, null, 8 /* PROPS */, ["value"])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            ($setup.refreshMessage)
              ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString($setup.refreshMessage), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            ($setup.data.can_send_weekly_task_summary)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  disabled: $setup.weeklySummarySending || !$setup.data.weekly_task_summary_configured,
                  title: $setup.data.weekly_task_summary_configured ? 'Сформировать и отправить сейчас' : 'Сначала настройте OpenRouter и рабочую модель',
                  onClick: $setup.sendWeeklyTaskSummary
                }, _toDisplayString($setup.weeklySummarySending ? "LLM обрабатывает…" : "Тест AI-сводки задач"), 9 /* TEXT, PROPS */, _hoisted_5))
              : _createCommentVNode("v-if", true),
            ($setup.data.can_send_daily_summary)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: $setup.summarySending,
                  onClick: $setup.sendDailySummary
                }, _toDisplayString($setup.summarySending ? "Запуск…" : "Отправить сводку за вчера"), 9 /* TEXT, PROPS */, _hoisted_6))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              disabled: $setup.refreshing,
              onClick: $setup.refreshData
            }, _toDisplayString($setup.refreshing ? "Импорт выполняется…" : "Обновить данные"), 9 /* TEXT, PROPS */, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("section", _hoisted_10, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "panel-title" }, [
                _createElementVNode("h2", null, "Показатели"),
                _createElementVNode("small", null, "Сегодня и текущий месяц")
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_RouterLink, {
                  to: "/partners",
                  class: "dashboard-metric-row"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _cache[2] || (_cache[2] = _createElementVNode("small", null, "Партнёры", -1 /* CACHED */)),
                      _createElementVNode("b", null, _toDisplayString($setup.data.available_partners) + " доступны", 1 /* TEXT */)
                    ]),
                    _createElementVNode("strong", null, _toDisplayString($setup.number($setup.data.partners)), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_RouterLink, {
                  to: "/tasks",
                  class: "dashboard-metric-row"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("small", null, "Открытые задачи", -1 /* CACHED */)),
                      _createElementVNode("b", {
                        class: _normalizeClass({danger:$setup.data.overdue_tasks})
                      }, _toDisplayString($setup.data.overdue_tasks) + " просрочено", 3 /* TEXT, CLASS */)
                    ]),
                    _createElementVNode("strong", null, _toDisplayString($setup.number($setup.data.open_tasks)), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_RouterLink, {
                  to: $setup.reportLink('report','registrations_count'),
                  class: "dashboard-metric-row"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _cache[4] || (_cache[4] = _createElementVNode("small", null, "Регистрации сегодня", -1 /* CACHED */)),
                      _createElementVNode("b", {
                        class: _normalizeClass(["metric-trend", $setup.change('registrations_count')])
                      }, _toDisplayString($setup.change('registrations_count').label), 3 /* TEXT, CLASS */)
                    ]),
                    _createElementVNode("strong", null, _toDisplayString($setup.number($setup.data.today.registrations_count)), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["to"]),
                _createVNode(_component_RouterLink, {
                  to: $setup.reportLink('report','first_deposits_count,first_deposits_sum'),
                  class: "dashboard-metric-row"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("small", null, "FTD сегодня", -1 /* CACHED */)),
                      _createElementVNode("b", {
                        class: _normalizeClass(["metric-trend", $setup.change('first_deposits_count')])
                      }, _toDisplayString($setup.change('first_deposits_count').label), 3 /* TEXT, CLASS */)
                    ]),
                    _createElementVNode("strong", null, [
                      _createTextVNode(_toDisplayString($setup.number($setup.data.today.first_deposits_count)) + " ", 1 /* TEXT */),
                      _createElementVNode("em", null, _toDisplayString($setup.money($setup.data.today.first_deposits_sum)), 1 /* TEXT */)
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["to"]),
                _createVNode(_component_RouterLink, {
                  to: $setup.reportLink('report','deposits_count,deposits_sum'),
                  class: "dashboard-metric-row"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("small", null, "Депозиты сегодня", -1 /* CACHED */)),
                      _createElementVNode("b", {
                        class: _normalizeClass(["metric-trend", $setup.change('deposits_sum')])
                      }, _toDisplayString($setup.change('deposits_sum').label), 3 /* TEXT, CLASS */)
                    ]),
                    _createElementVNode("strong", null, _toDisplayString($setup.money($setup.data.today.deposits_sum)), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["to"]),
                _createVNode(_component_RouterLink, {
                  to: "/reports?type=report",
                  class: "dashboard-metric-row bonus"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("small", null, "Бонус партнёров за месяц · 3%", -1 /* CACHED */)),
                      _createElementVNode("b", {
                        class: _normalizeClass(["metric-trend", $setup.bonusChange()])
                      }, _toDisplayString($setup.bonusChange().label), 3 /* TEXT, CLASS */)
                    ]),
                    _createElementVNode("strong", null, [
                      _createTextVNode(_toDisplayString($setup.money($setup.data.monthly_bonus.current)) + " ", 1 /* TEXT */),
                      _createElementVNode("em", null, "прошлый: " + _toDisplayString($setup.money($setup.data.monthly_bonus.previous)), 1 /* TEXT */)
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _createElementVNode("section", _hoisted_12, [
              _createVNode($setup["FtdSumChart"], {
                series: $setup.data.ftd_sum_series
              }, null, 8 /* PROPS */, ["series"])
            ])
          ]),
          _createElementVNode("aside", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[10] || (_cache[10] = _createElementVNode("div", null, [
                _createElementVNode("h2", null, "Ближайшие задачи"),
                _createElementVNode("small", null, "Сегодня и после сегодня · максимум 5")
              ], -1 /* CACHED */)),
              _createVNode(_component_RouterLink, { to: "/tasks" }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("Все задачи →", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.upcoming_tasks, (task) => {
                return (_openBlock(), _createBlock(_component_RouterLink, {
                  key: task.id,
                  to: `/tasks/${task.id}`,
                  class: "dashboard-task-row"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString($setup.taskPeriod(task)), 1 /* TEXT */),
                      _createElementVNode("strong", null, _toDisplayString(task.title), 1 /* TEXT */),
                      _createElementVNode("small", null, _toDisplayString(task.partner?.name || 'Без партнёра') + " · " + _toDisplayString(task.assignee.name), 1 /* TEXT */)
                    ]),
                    _createVNode($setup["DualTime"], {
                      value: task.deadline_at
                    }, null, 8 /* PROPS */, ["value"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
              }), 128 /* KEYED_FRAGMENT */)),
              (!$setup.data.upcoming_tasks.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Нет ближайших задач с дедлайном"))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", null, [
              _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Задачи по стадиям", -1 /* CACHED */)),
              _createElementVNode("small", null, "Созданы за " + _toDisplayString($setup.dateOnly($setup.data.task_stage_stats.from)) + "–" + _toDisplayString($setup.dateOnly($setup.data.task_stage_stats.to)) + " · всего " + _toDisplayString($setup.number($setup.data.task_stage_stats.total)), 1 /* TEXT */)
            ]),
            _createVNode(_component_RouterLink, { to: "/tasks" }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("Открыть доску →", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            })
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.task_stage_stats.stages, (stage) => {
              return (_openBlock(), _createElementBlock("div", {
                key: stage.id,
                class: "dashboard-task-stage"
              }, [
                _createElementVNode("header", null, [
                  _createElementVNode("span", {
                    class: "stage-dot",
                    style: _normalizeStyle({background:stage.color})
                  }, null, 4 /* STYLE */),
                  _createElementVNode("strong", null, _toDisplayString(stage.name), 1 /* TEXT */),
                  _createElementVNode("b", null, _toDisplayString($setup.number(stage.count)), 1 /* TEXT */)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("i", {
                    style: _normalizeStyle({width:$setup.taskStageWidth(stage.count),background:stage.color})
                  }, null, 4 /* STYLE */)
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _cache[14] || (_cache[14] = _createElementVNode("h2", null, "Последние импорты", -1 /* CACHED */)),
            _createVNode(_component_RouterLink, { to: "/imports" }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("Все импорты →", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            })
          ]),
          _createElementVNode("table", null, [
            _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Тип"),
                _createElementVNode("th", null, "Дата"),
                _createElementVNode("th", null, "Строк"),
                _createElementVNode("th", null, "Статус")
              ])
            ], -1 /* CACHED */)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.recent_imports, (run) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: run.id
                }, [
                  _createElementVNode("td", null, _toDisplayString($setup.IMPORT_KIND_LABELS[run.kind] || run.kind), 1 /* TEXT */),
                  _createElementVNode("td", null, [
                    (run.period_date)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString($setup.dateOnly(run.period_date)), 1 /* TEXT */))
                      : (_openBlock(), _createBlock($setup["DualTime"], {
                          key: 1,
                          value: run.created_at
                        }, null, 8 /* PROPS */, ["value"]))
                  ]),
                  _createElementVNode("td", null, _toDisplayString($setup.number(run.records_count)), 1 /* TEXT */),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["status", run.status])
                    }, _toDisplayString($setup.STATUS_LABELS[run.status] || run.status), 3 /* TEXT, CLASS */)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_24, "Загрузка…"))
}